import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

function DeleteButton({ onClick }) {
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement='top'
      overlay={
        <Popover className='popover-basic'>
          <Popover.Content>Delete</Popover.Content>
        </Popover>
      }
    >
      <button className='btn btn-link' onClick={onClick}>
        <span className='sr-only'>Delete</span>
        <i className='fas fa-trash-alt' aria-hidden='true'></i>
      </button>
    </OverlayTrigger>
  );
}

export default DeleteButton;
